import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiModels, HttpService } from '@mona/api';
import { Encounter, InfectionStatus } from '@mona/models';
import { transformApiInfections } from '@mona/pdms/data-access-encounter-data';

/**
 * API abstraction layer for the infection status API
 */
@Injectable({
    providedIn: 'root',
})
export class InfectionStatusApi {
    apiBase = '/pdms/infection-status/';

    /**
     * Constructor
     *
     * @param http HttpClient
     */
    constructor(private http: HttpService) {}

    /**
     * Get infections
     *
     * @param encounterId EntityId<Encounter>
     */
    getInfectionStatus(encounterId?: EntityId<Encounter>): Observable<InfectionStatus[]> {
        const params: { [param: string]: string | string[] } = {};

        if (encounterId) {
            params.encounter_id = `${encounterId}`;
        }

        return this.http
            .get<ApiModels.InfectionStatus[]>(this.apiBase, { params })
            .pipe(map(infection => transformApiInfections(infection)));
    }
}
